import * as React from "react";
import * as Icons from "./Icons";
import useConfig from "../hooks/useConfig";

interface Props {
  options: string[];
  onSubmit: (selection: string) => void;
}

export default function ChatNessageSelect(props: Props) {
  const [selection, setSelection] = React.useState(props.options[0]);
  const configContext = useConfig();

  function onKeyDown(e: any) {
    if (e.which === 13) {
      props.onSubmit(selection);
    }
  }

  return (
    <div className="velaro-message-form velaro-message-form-select">
      <select
        value={selection}
        onChange={e => setSelection(e.currentTarget.value)}
        onKeyDown={onKeyDown}
      >
        {props.options.map((x, i) => (
          <option
            role="option"
            aria-selected={selection === x}
            key={i}
            value={x}
          >
            {x}
          </option>
        ))}
      </select>
      <div className="velaro-message-form-actions">
        <button
          className="velaro-message-send-button velaro-bg-primary"
          onClick={() => {
            props.onSubmit(selection);
          }}
          role="button"
          aria-label="Send Message"
        >
          <Icons.SendIcon color={configContext.PrimaryTextColor} />
        </button>
      </div>
    </div>
  );
}
